import React from 'react';

import {
  StatusBadgeSize,
  StatusBadgeVariant,
  StyledStatusBadge,
} from './styles';

export type StatusBadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?: StatusBadgeVariant;
  size?: StatusBadgeSize;
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
  icon?: React.ReactNode;
};

const StatusBadge = ({
  variant = 'info',
  size = 'medium',
  color,
  backgroundColor,
  borderColor,
  icon,
  children,
  ...rest
}: StatusBadgeProps): JSX.Element => {
  return (
    <StyledStatusBadge
      $variant={variant}
      $size={size}
      $color={color}
      $backgroundColor={backgroundColor}
      $borderColor={borderColor}
      {...rest}
    >
      {icon && <span>{icon}</span>}
      {children}
    </StyledStatusBadge>
  );
};

export default StatusBadge;
